import React from "react";

import "./index.scss";

const SubSection = ({ title, subTitle, icon, children }) => {
  return (
    <div className="subsection">
      <div className="subsection-title">
        {icon}
        <span>{title}</span>
      </div>

      {subTitle && <div className="subsection-sub-title">{subTitle}</div>}

      <div className="subsection-table">{children}</div>
    </div>
  );
};

export default SubSection;
